<div *ngIf="GroupType != undefined || selectedMenu != undefined">
  <app-common-skeleton *ngIf="isAllowedUsers() && isLoading" [countforView]="1"
    [NameOftheScreen]="'widgets'"></app-common-skeleton>

  <div class="card-900" *ngIf="isAllowedUsers() && !isLoading">
    <div class="user-details-900" *ngIf="!nodatafound; else noData">

      <!-- Centered profile header -->
      <div class="profile-head-900">
        <img *ngIf="Jobandcandidatedetails.user?.photo" alt="logo" class="pic-size-900"
          [src]="url + Jobandcandidatedetails.user.photo">
        <div *ngIf="!Jobandcandidatedetails.user?.photo" class="circles-900"
          [style.background-color]="getColortwo(Jobandcandidatedetails.user?.firstName, Jobandcandidatedetails.user?.lastName)">
          <div class="circle-text-900"
            [style.color]="getTextColor(Jobandcandidatedetails.user?.firstName, Jobandcandidatedetails.user?.lastName)">
            {{ getInitialstwo(Jobandcandidatedetails.user?.firstName, Jobandcandidatedetails.user?.lastName) }}
          </div>
        </div>

        <div class="profile-name-900"
          *ngIf="Jobandcandidatedetails?.user?.firstName || Jobandcandidatedetails?.user?.lastName"
          title="{{ Jobandcandidatedetails?.user?.firstName }} {{ Jobandcandidatedetails?.user?.lastName }}">
          {{ Jobandcandidatedetails?.user?.firstName }} {{ Jobandcandidatedetails?.user?.lastName }}
        </div>

        <div class="profile-role-900"
          *ngIf="getProfileSubtitle(Jobandcandidatedetails?.user)"
          title="{{ getProfileSubtitle(Jobandcandidatedetails?.user) }}">
          {{ getProfileSubtitle(Jobandcandidatedetails?.user) }}
        </div>

        <div class="stat-grid-900">
          <div class="stat-900">
            <div class="stat-val-900">{{ Jobandcandidatedetails?.user?.connectionCnt || 0 }}</div>
            <div class="stat-lbl-900">Connections</div>
          </div>
          <div class="stat-900">
            <div class="stat-val-900">{{ Jobandcandidatedetails?.user?.jobsActiveCount || 0 }}</div>
            <div class="stat-lbl-900">Jobs</div>
          </div>
          <div class="stat-900">
            <div class="stat-val-900">{{ Jobandcandidatedetails?.user?.candidatesActiveCount || 0 }}</div>
            <div class="stat-lbl-900">Candidates</div>
          </div>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="profile-section-900"
        *ngIf="isUserChat() && (Jobandcandidatedetails?.user?.email || Jobandcandidatedetails?.user?.phoneNo || Jobandcandidatedetails?.user?.organisation)">
        <div class="profile-section-title-900">Contact Info</div>
        <div class="profile-row-900" *ngIf="Jobandcandidatedetails?.user?.email">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          <!-- Masked exactly like the candidate profile slider (cp-header): the
               literal "[ email protected ]" placeholder — blue, darker blue +
               underline on hover. -->
          <p class="email-protected-900">[ email protected ]</p>
        </div>
        <div class="profile-row-900" *ngIf="Jobandcandidatedetails?.user?.phoneNo">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          <p title="{{ Jobandcandidatedetails?.user?.phoneNo }}">{{ Jobandcandidatedetails?.user?.phoneNo }}</p>
        </div>
        <div class="profile-row-900" *ngIf="Jobandcandidatedetails?.user?.organisation">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
          <p title="{{ Jobandcandidatedetails?.user?.organisation }}">{{ Jobandcandidatedetails?.user?.organisation }}</p>
        </div>
      </div>

      <!-- Quick Actions -->
      <div class="profile-section-900" *ngIf="isUserChat()">
        <div class="profile-section-title-900">Quick Actions</div>
        <button type="button" class="qa-btn-900 qa-btn-primary-900" (click)="onViewProfile()">View Full Profile</button>
        <button type="button" class="qa-btn-900 qa-btn-outline-900" disabled>Share a Job</button>
      </div>
    </div>

    <ng-template #noData>
      <div class="no-data-message-900" *ngIf="nodatafound">
        <ng-icon name="tablerMailOff"></ng-icon>
        <p style="text-align: center;"> No data to display </p>
      </div>
    </ng-template>
  </div>
</div>

<!-- //Candidate Details -->
<div *ngIf="GroupType!=undefined||selectedMenu!=undefined">
  <app-common-skeleton *ngIf="( GroupType=='CANDIDATE' ||  selectedMenu=='CANDIDATE')&&isLoading" [countforView]="1"
    [NameOftheScreen]="'widgets'"></app-common-skeleton>
  <div class="card1-900" *ngIf="( GroupType=='CANDIDATE' ||  selectedMenu=='CANDIDATE')&&!isLoading">
    <div *ngIf="!nodatafound; else noData">
      <p><b>Candidate Details</b></p>
      <hr>
      <div class="mr-0">
        <div class="detail-row-900">
          <div class="label-900">Candidate ID</div>
          <div class="value-900">{{Jobandcandidatedetails?.entity?.candidateId}}</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Name</div>
          <div title="{{Jobandcandidatedetails?.entity?.firstName}} {{Jobandcandidatedetails?.entity?.lastName}}"
            class="value-900">{{Jobandcandidatedetails?.entity?.firstName}} {{Jobandcandidatedetails?.entity?.lastName}}
          </div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Title</div>
          <div title="{{Jobandcandidatedetails?.entity?.jobTitle}}" class="value-900">
            {{Jobandcandidatedetails?.entity?.jobTitle}}</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Skills</div>
          <div class="value-900 value-skills-900">
            <div *ngFor="let item of Jobandcandidatedetails?.entity?.primarySkills | slice:0:3" class="skill-item-900"
              title="{{ item }}">
              {{ item }}
            </div>
          </div>
        </div>

        <div class="detail-row-900">
          <div class="label-900">Experience</div>
          <div class="value-900">{{Jobandcandidatedetails?.entity?.totalExperience}} Years</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Location</div>
          <div title="{{Jobandcandidatedetails?.entity?.city}} ,{{Jobandcandidatedetails?.entity?.state}}"
            class="value-900">{{Jobandcandidatedetails?.entity?.city}} ,{{Jobandcandidatedetails?.entity?.state}}</div>
        </div>
        <div class="detail-row-900">
          <div [title]="
            (Jobandcandidatedetails.entity?.country === 'US' ? '$' : '') +
            Jobandcandidatedetails.entity?.targetRateFrom + ' - ' + Jobandcandidatedetails.entity?.targetRateTo + ' ' +
            getJobCurrency(Jobandcandidatedetails.entity) + ' / ' +
            getPayType(Jobandcandidatedetails.entity?.payType)"
            *ngIf="Jobandcandidatedetails.entity?.targetRateFrom != undefined && Jobandcandidatedetails.entity?.targetRateTo != undefined"
            class="label-900">
            Rate
          </div>
          <div class="value-900">
            <span>
              {{Jobandcandidatedetails.entity?.country === 'US' ? '$' : ''}}
              {{Jobandcandidatedetails.entity?.targetRateTo}}
            </span>
            <span>{{getJobCurrency(Jobandcandidatedetails.entity)}} /
              {{getPayType(Jobandcandidatedetails.entity?.payType)}}</span>
          </div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Positions</div>
          <div class="value-900"> 1</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Status</div>
          <div class="value-900"> Open</div>
        </div>
      </div>
    </div>
    <ng-template #noData>
      <div class="no-data-message-900" *ngIf="nodatafound">
        <ng-icon name="tablerMailOff"></ng-icon>
        <p style="text-align: center;"> No data to display </p>
      </div>
    </ng-template>
  </div>
</div>
<!-- //Job Details -->
<div *ngIf="GroupType!=undefined||selectedMenu!=undefined">
  <app-common-skeleton *ngIf="(GroupType=='JOB' || selectedMenu=='JOB')&&isLoading" [countforView]="1"
    [NameOftheScreen]="'widgets'"></app-common-skeleton>
  <div class="card1-900" *ngIf="(GroupType=='JOB' || selectedMenu=='JOB')&&!isLoading">
    <div *ngIf="!nodatafound; else noData">
      <p><b>Job Details</b></p>
      <hr>
      <div class="mr-0">
        <div class="detail-row-900">
          <div class="label-900">Job ID</div>
          <div class="value-900">{{Jobandcandidatedetails?.entity?.jobId}}</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Title</div>
          <div title="{{Jobandcandidatedetails?.entity?.jobTitle}}" class="value-900">
            {{Jobandcandidatedetails?.entity?.jobTitle}}</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Skills</div>
          <div class="value-900 value-skills-900">
            <div *ngFor="let item of Jobandcandidatedetails?.entity?.primarySkills | slice:0:3" class="skill-item-900"
              title="{{ item }}">
              {{ item }}
            </div>
          </div>
        </div>

        <div class="detail-row-900">
          <div class="label-900">Experience</div>
          <div class="value-900">{{Jobandcandidatedetails?.entity?.experienceFrom}} to
            {{Jobandcandidatedetails?.entity?.experienceTo}} Years</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Location</div>
          <div title="{{Jobandcandidatedetails?.entity?.city}} ,{{Jobandcandidatedetails?.entity?.state}}"
            class="value-900">{{Jobandcandidatedetails?.entity?.city}} ,{{Jobandcandidatedetails?.entity?.state}}</div>
        </div>
        <div class="detail-row-900">
          <div [title]="
          (Jobandcandidatedetails.entity?.country === 'US' ? '$' : '') +
          Jobandcandidatedetails.entity?.targetRateFrom + ' - ' + Jobandcandidatedetails.entity?.targetRateTo + ' ' +
          getJobCurrency(Jobandcandidatedetails.entity) + ' / ' +
          getPayType(Jobandcandidatedetails.entity?.payType)"
            *ngIf="Jobandcandidatedetails.entity?.targetRateFrom != undefined && Jobandcandidatedetails.entity?.targetRateTo != undefined"
            class="label-900">
            Rate
          </div>
          <div class="value-900">
            <span>
              {{Jobandcandidatedetails.entity?.country === 'US' ? '$' : ''}}
              {{Jobandcandidatedetails.entity?.targetRateTo}}
            </span>
            <span>{{getJobCurrency(Jobandcandidatedetails.entity)}} /
              {{getPayType(Jobandcandidatedetails.entity?.payType)}}</span>
          </div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Positions</div>
          <div class="value-900"> 1</div>
        </div>
        <div class="detail-row-900">
          <div class="label-900">Status</div>
          <div class="value-900"> Open</div>
        </div>
      </div>
    </div>
    <ng-template #noData>
      <div class="no-data-message-900" *ngIf="nodatafound">
        <ng-icon name="tablerMailOff"></ng-icon>
        <p style="text-align: center;"> No data to display </p>
      </div>
    </ng-template>
  </div>
</div>
<!-- //Group Details -->
<div *ngIf="(GroupType!=undefined||selectedMenu!=undefined) && isAllowed()">
  <app-common-skeleton *ngIf="isAllowedGroup()&&(loadApicall||isLoading)" [countforView]="1"
    [NameOftheScreen]="'userChat'"></app-common-skeleton>
  <div #entityContainer *ngIf="isAllowedGroup() && !loadApicall && !isLoading && !nodatafound"
    class="groupcard-900 sub-entities-scroll-container-900" id="entity-container" infiniteScroll
    [infiniteScrollDistance]="5" [infiniteScrollThrottle]="150" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <div class="user-card-900" *ngFor="let user of connectionlistuserdata | async">
      <!-- Profile Image or Initials -->
      <div *ngIf="user?.photo">
        <img alt="logo" class="img pic-size-900" [src]="url + user.photo">
      </div>
      <div *ngIf="!user?.photo">
        <div class="circles-900" [style.background-color]="getColortwo(user?.firstName, user?.lastName)">
          <div class="circle-text-900" [style.color]="getTextColor(user?.firstName, user?.lastName)">
            {{ getInitialstwo(user?.firstName, user?.lastName) }}
          </div>
        </div>
      </div>
      <div class="user-info-900">
        <div class="groupuser-details-900">
          <div class="user-top-900">
            <span title="{{ user.firstName}} {{user.lastName}}" class="user-name-900">{{ user.firstName }}
              {{user.lastName}}</span>
            <span title="{{ user.online}}" class="user-status-900"
              [ngClass]="{'online-900': user.online === 'ONLINE', 'offline-900': user.online === 'OFFLINE'}">
              ● {{ user.online | titlecase }}
            </span>
          </div>
          <div title="{{ getMemberSubtitle(user) }}" class="user-title-900">{{ getMemberSubtitle(user) }}</div>
        </div>
      </div>
    </div>
    <!-- Loading more (scroll pagination) — skeleton instead of the util spinner -->
    <app-common-skeleton *ngIf="loadingMore" [NameOftheScreen]="'userChat'"></app-common-skeleton>

    <div class="no-data-message-900" *ngIf="(connectionlistuserdata | async)?.length==0&&!nodatafound">
      <ng-icon name="tablerMailOff"></ng-icon>
      <p style="text-align: center;"> No data to display </p>
    </div>
  </div>
  <!-- No-data shows ONLY after loading finishes (not alongside the skeleton) -->
  <div class="no-data-message-900" style="margin-top: 0.3rem;"
    *ngIf="isAllowedGroup() && !loadApicall && !isLoading && nodatafound">
    <ng-icon name="tablerMailOff"></ng-icon>
    <p style="text-align: center;"> No data to display </p>
  </div>
</div>